import * as React from 'react';
import styled from 'styled-components';
import { LoginForm } from '@bart.sk-eshop/eshop-defaults';
import { doc } from 'prettier';

interface Props {
  baseApiUrl: string;
  baseUrl: string;
  cartId?: string;
  pathname: string;
  search: string;
  error: string;
  lang: string;
  onFacebookLogin: () => void;
  onGoogleLogin: () => void;
}

const Wrapper = styled.div`
  position: relative;
`;

const hasCookie = (name: string, value: string): boolean => {
  if (typeof document === 'undefined') return false;
  return document.cookie.split(';').some(c => {
    const [k, v] = c.trim().split('=');
    return k === name && v === value;
  });
};

const LoginFormWrapper: React.FC<Props> = ({
  baseApiUrl,
  baseUrl,
  cartId,
  pathname,
  search,
  error,
  lang,
  onFacebookLogin,
  onGoogleLogin,
}) => {
  const showSocialButtons = true;

  return (
    <Wrapper>
      <LoginForm
        baseApiUrl={baseApiUrl}
        baseUrl={baseUrl}
        cartId={cartId}
        pathname={pathname}
        search={search}
        error={error}
        lang={lang}
        showFacebookLoginButton={showSocialButtons}
        showGoogleLoginButton={showSocialButtons}
        onFacebookLogin={onFacebookLogin}
        onGoogleLogin={onGoogleLogin}
      />
    </Wrapper>
  );
};

export default LoginFormWrapper;
